import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import GameContentProvider from '../providers/GameContentProvider';
import { handleLogout } from '../auth/authSlice';
import './MyGames.css';
import copyIcon from '../assets/copy-icon.png';
import { useTranslation } from 'react-i18next';
import AuthenticationProvider from '../providers/AuthenticationProvider';
import { downloadVoucher } from "../utils/voucherGenerator";


const MyGames = () => {
  const { t, i18n } = useTranslation();

  const [games, setGames] = useState([]);
  const [teams, setTeams] = useState([]);
  const [coupons, setCoupons] = useState([]);
  const [numberOfPoints, setNumberOfPoints] = useState(0);
  const [referralLink, setReferralLink] = useState("");
  const [deleteProfile, setDeleteProfile] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const domain = window.location.origin;

  useEffect(() => {
    const fetchUserGames = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          // Redirect to login if token is not found
          navigate('/login');
          return;
        }
        const gameProvider = new GameContentProvider();
        const result = await gameProvider.getUserGames(token, (i18n.language || 'bg').substring(0, 2));
        console.log(result);

        setGames(result.games);
        setTeams(result.teams);
        setCoupons(result.coupons);
        setNumberOfPoints(result.referralPoints);
        // Construct the referral link
        const constructedReferralLink = `${domain}/ref/${result.user_id}`;

        // Set the referral link state
        setReferralLink(constructedReferralLink);
      } catch (error) {
        console.error('Error fetching user games:', error);
        // Handle error as needed
      }
    };

    fetchUserGames();
  }, [navigate, domain, i18n.language]);  // Add 'domain' to the dependencies


  const handleDeleteProfile = () => {
    setDeleteProfile(true);

  };


  const setConfirmDeleteProfile = async () => {
    console.log("Delete Profile");

    const authenticationProvider = new AuthenticationProvider();
    const token = localStorage.getItem('token');
    if (!token) {
      console.log("No token available");
      return;
    }
    const result = await authenticationProvider.deleteUser(token);
    console.log(result);
    if (!result.success) {
      console.log("Could not delete user: " + token);
      setDeleteProfile(false);
    }
    else {
      //Successfully deleted
      dispatch(handleLogout());
      navigate('/');
    }


  };


  const setCloseOverlay = () => {
    setDeleteProfile(false);

  };


  const handleLogoutClick = () => {
    dispatch(handleLogout());
    navigate('/');
  };

  const handleGameClick = (game) => {
    console.log("Handle Game Click");
    console.log(game);

    if ((game.completed) || new Date(game.end_date) < new Date()) {
      // Game has ended, navigate to game overview
      const data = {
        game: game.game_id,
        play_id: game.play_id,
      };
      navigate('/game-overview', { state: data });
    } else {
      // Game is still ongoing, handle accordingly
      console.log("Game ongoing. Open Game steps");

      const data = {
        game: game.game_id,
        step: game.last_step,
        type: 1,
        play_id: game.play_id,
        duration: game.duration,
        number_of_steps: game.number_of_steps,
      };

      const gameStepsWindow = window.open("/game-steps/", '_blank');
      gameStepsWindow.addEventListener('load', () => {
        gameStepsWindow.postMessage(data, window.origin);
      });
    }
  }

  const handleTeamGameClick = (team) => {
    console.log("Handle Team Click");
  }

  const handleCouponClick = (coupon) => {
    console.log(coupon);
    const data = {
      coupon: coupon.coupon_name,
    };
    if (new Date(coupon.end_date) < new Date()) {
      console.log("Coupons is expored");
    }
    else if (coupon.voucher == 0) {
      navigate('/start_game', { state: data });
    }
    else {
      console.log("Voucher");

      downloadVoucher({
        coupon: coupon.coupon_name,
        voucherName: coupon.voucher_name,
        voucherWish: coupon.voucher_wish,
        endDate: coupon.end_date,
        gameName: coupon.game_title,
        gameDescription: coupon.game_description,
        imageUrl: coupon.game_image_url,
        language: (i18n.language || 'bg').substring(0, 2)
      });



    }
  }



  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  // Function to copy referral link to clipboard
  const copyToClipboard = () => {
    navigator.clipboard.writeText(referralLink);
    // You can add additional logic or state updates after copying
    console.log('Referral link copied to clipboard');
  };

  return (
    <div className="my-games-container">
      {/* Display coupons */}
      {coupons && coupons.length > 0 ? (
        <>
          <div className="coupons-divider"></div>
          <div className="coupons-container">
            <h2 className="items-title"> {t("my_coupons")}</h2>
            <div className="items-container">
              {coupons.map((coupon, index) => (
                <div
                  key={coupon.coupon_id}
                  className={`coupon-card ${index === coupons.length - 1 ? 'last-item' : ''}`}
                  onClick={() => handleCouponClick(coupon)}
                >
                  <img className="coupon-image" src={coupon.game_image_url} alt={coupon.game_title} />
                  <div className="coupon-info">
                    <h4> {t("coupon")}: {coupon.coupon_name}</h4>
                    <p> {t("game")}: {coupon.game_title}</p>
                    <p className="small-text"> {t("order_date")}: {formatDate(coupon.order_date)}</p>
                    <p className="small-text"> {t("expiration_date")}: {formatDate(coupon.end_date)}</p>
                  </div>
                  {new Date(coupon.end_date) < new Date() ? (
                    <div className="coupon-overlay" data-text={t('couponExpired')}></div>
                  ) : (
                    coupon.voucher && <div className="coupon-overlay2"></div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </>
      ) : (
        <div className="no-coupons-container" style={{ textAlign: 'center', margin: '30px 0' }}>
          <p style={{ fontWeight: 'bold' }}>{t('currently_no_coupons')}</p>
          <button className="logout-button" style={{ marginTop: '10px' }} onClick={() => navigate('/games')}>
            {t('go_to_games')}
          </button>
        </div>
      )}

      {teams && teams.length > 0 && (
        <>
          <div className="games-divider"></div>
          <div className="games-container">
            <h2 className="items-title"> {t("my_team_games")}</h2>
            <div className="items-container">
              {teams.map((team, index) => (
                <div
                  key={team.team_id}
                  className={`game-card ${new Date(team.end_date) < new Date() ? 'ended' : ''} ${index === teams.length - 1 ? 'last-item' : ''}`}
                  onClick={() => handleTeamGameClick(team)} // Attach onClick event handler
                >
                  <img className="game-image" src={team.game_image_url} alt={team.game_title} />
                  <div className="game-info">
                    <h4> {t("game")}: {team.game_title}</h4>
                    <p> {t("your_team")}: {team.team_name}</p>
                    <p className="small-text">: {formatDate(team.start_date)}</p>
                  </div>
                  {new Date(team.end_date) < new Date() && <div
                    className="overlayMyGames"
                    style={{ '--overlayText': `"${t('gameEnded')}"` }}
                  ></div>}
                </div>
              ))}
            </div>
          </div>
        </>
      )}


      {/* Display games */}
      {games && games.length > 0 && (
        <>
          <div className="games-divider"></div>
          <div className="games-container">
            <h2 className="items-title"> {t("my_games")}</h2>
            <div className="items-container">
              {games.map((game, index) => (
                <div
                  key={game.game_id}
                  className={`game-card ${new Date(game.end_date) < new Date() ? 'ended' : ''} ${index === games.length - 1 ? 'last-item' : ''}`}
                  onClick={() => handleGameClick(game)} // Attach onClick event handler
                >
                  <img className="game-image" src={game.game_image_url} alt={game.game_title} />
                  <div className="game-info">
                    <h4> {t("game")}: {game.game_title}</h4>
                    <p> {t("your_team")}: {game.team_name}</p>
                    <p className="small-text"> {t("started")}: {formatDate(game.start_date)}</p>
                  </div>
                  {new Date(game.end_date) < new Date() && <div className="overlayMyGames"></div>}
                </div>
              ))}
            </div>
          </div>
          <div className="games-divider"></div>
        </>
      )}

      <div>
        <p>
          {t("your_referral_points")}: <span style={{ color: 'red', fontWeight: 'bold' }}>{numberOfPoints}</span>
        </p>
        <p>
          {t("your_referral_link")}: <span style={{ fontStyle: 'italic', color: 'blue' }}>{referralLink}</span>
          <button onClick={copyToClipboard} style={{ marginLeft: '10px', padding: '5px', backgroundColor: 'transparent', border: 'none' }}>
            <img src={copyIcon} alt="Copy Icon" style={{ width: '20px', height: '20px' }} /> {/* Use local copy icon image */}
          </button>
        </p>
        <p> {t("invite_friends")}</p>
      </div>

      <div className="button-container">
        <button className="logout-button" onClick={handleLogoutClick}>
          {t("logout")}
        </button>
        <button className="logout-button" onClick={handleDeleteProfile}>
          {t("delete_profile")}
        </button>
      </div>

      {/* Game completed overlay */}
      {deleteProfile && (
        <div className="overlay">
          <div className="overlay-content">
            <p>{t("confirm_delete")}</p>
            <button onClick={() => setConfirmDeleteProfile()}>{t("delete_profile")}</button>
            <button onClick={() => setCloseOverlay()}>{t("close")}</button>
          </div>
        </div>
      )}
    </div>
  );

};

export default MyGames;
